import React from 'react';
import { convertValueToUSD } from '../../../../helpers/currency.helper';
import { LiliTransaction } from '../../types/lili-transaction';
import { TransactionCheckStatus } from '../../enum/transaction-check-status';

/**
 * Used for the amount column. renders the value as a string
 * with a dollar sign and matched color: -$100.00 | $100.00
 */

export const amountTemplate = (t: LiliTransaction) => {
  const isExpense = t.amount < 0;
  const isRejected = t.checkDetailsData?.status === TransactionCheckStatus.REJECT;
  const isBounced = t.checkDetailsData?.status === TransactionCheckStatus.BOUNCED;

  const parsedAmount = convertValueToUSD(t.amount, 2);

  return <p id='amount' className={` ${(isRejected || isBounced) ? 'text-bw06 line-through' : isExpense ? 'text-bw07' : 'text-badgeGreen03'} font-metricRSemibold text-right`}>{parsedAmount}</p>;
};
